import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";

interface CoachProfileProps {
  open: boolean;
  onOpenChange: (v: boolean) => void;
  canBuyCoach?: boolean;
  onBuyCoach?: (coach: {
    id: string;
    name: string;
    price?: number;
    currency?: string;
  }) => Promise<void> | void;
  isBuyingCoach?: boolean;
  coach: {
    id: string;
    name: string;
    bio?: string;
    specialties?: string[];
    experience?: string;
    image?: string;
    price?: number;
    currency?: string;
  } | null;
}

export function CoachProfile({
  open,
  onOpenChange,
  coach,
  canBuyCoach = true,
  onBuyCoach,
  isBuyingCoach = false,
}: CoachProfileProps) {
  if (!coach) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg w-[calc(100vw-2rem)] max-h-[85vh] overflow-y-auto overflow-x-hidden">
        <DialogHeader>
          <DialogTitle>Coach Profile</DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          {coach.image && (
            <img
              src={coach.image}
              alt="Coach"
              className="w-32 h-32 rounded-full object-cover mx-auto"
            />
          )}

          <h2 className="text-xl font-semibold text-center break-all [overflow-wrap:anywhere]">{coach.name}</h2>

          {coach.bio && (
            <p className="text-sm text-muted-foreground whitespace-pre-wrap break-all [overflow-wrap:anywhere]">
              {coach.bio}
            </p>
          )}

          {coach.experience && (
            <div>
              <h3 className="font-semibold">Experience</h3>
              <p className="text-sm text-muted-foreground whitespace-pre-wrap break-all [overflow-wrap:anywhere]">
                {coach.experience}
              </p>
            </div>
          )}

          {coach.specialties && coach.specialties.length > 0 && (
            <div>
              <h3 className="font-semibold">Specialties</h3>
              <ul className="list-disc ml-5 text-sm text-muted-foreground break-all [overflow-wrap:anywhere]">
                {coach.specialties.map((s, i) => (
                  <li key={i}>{s}</li>
                ))}
              </ul>
            </div>
          )}

          <div className="pt-2">
            <p className="text-sm text-muted-foreground">Session Price</p>
            <p className="text-xl font-semibold">
              {(coach.currency || "USD").toUpperCase()} {coach.price ?? 0}
            </p>
          </div>

          <div className="flex justify-end gap-2 pt-4">
            {canBuyCoach && (
              <Button
                onClick={() => onBuyCoach?.(coach)}
                disabled={isBuyingCoach}
              >
                {isBuyingCoach ? "Processing..." : "Buy"}
              </Button>
            )}
            <Button onClick={() => onOpenChange(false)}>Close</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
